import React from 'react';
import { AppConfig } from '../../app/AppConfig';
import { SidebarListItem } from './SidebarListItem';

const SideBarList = (props) => {
  const SidebarItems = AppConfig.pages.map((page, index) => {
    return (
      <SidebarListItem
        caption={page.name}
        url={page.url}
        key={index}
        icon={page.sideBarIcon}
      />
    );
  });

  return (
    <>
      {SidebarItems}
      {/*<SidebarListItem caption={'Home'} icon={<HomeIcon />} url={'home'} />*/}
      {/*<SidebarListItem caption={'Getting Started'} icon={<RocketLaunchIcon />} url={'getting_started'} />*/}
      {/*<SidebarListItem caption={'Documentation'} icon={<LibraryBooksIcon />} url={'documentation'} />*/}
    </>
  );
};

SideBarList.propTypes = {};

SideBarList.defaultProps = {};

export { SideBarList };
